import React, { useEffect, useState } from 'react'
import { View } from 'react-native'

import { AbsoluteSpinner, Spinner } from '../../../App/Components'
import { addMenu } from '../../../Appointment/store/Actions'
import { useHistory, useLocation, useParams } from '../../../Router'
import { ListStructureMap } from '../../Menu/Components/ListStructure/Components/ListStructureMap/ListStructureMap'
import { IMenuCategory } from '../../Store/IMenuCategory'
import { isPersonSelectableCheck } from '../../utils/isPersonSelectableCheck/isPersonSelectableCheck'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { personSelectPathCheck } from '../../../App/Util/personSelectPathCheck'
import { menuCategoryFilter } from '../../../App/Util/menuCategoryFilter'

export const ListStructure = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const history = useHistory()
  const { establishmentId } = useParams<{ [key: string]: string }>()

  const [currentCategories, setCurrentCategories] = useState(null)

  const settings = useAppSelector((state) => state.settings.values)
  const categories = useAppSelector((state) => state.menu.categories)
  const currentCustomerIndex = useAppSelector(
    (state) => state.appointment.currentCustomerIndex
  )
  const lastMinutes = useAppSelector((state) => state.lastMinute.list)
  const isExistingCustomer = useAppSelector(
    (state) => state.settings.isCustomerExisting
  )

  const getCurrentCategories = (
    breadcrumbs: number[],
    menuCategories: IMenuCategory[]
  ): undefined | IMenuCategory[] => {
    if (!settings) return undefined

    if (breadcrumbs.length === 0) {
      return menuCategoryFilter(
        menuCategories,
        settings.isCertainServiceBlock,
        isExistingCustomer
      )
    }

    const menuCategory = menuCategories.find(
      (category: IMenuCategory) => category.id === breadcrumbs[0]
    )
    if (!menuCategory || !menuCategory.categories) {
      // OB-519: the URL can carry a breadcrumb id that does not exist in the
      // fetched menu — a stale deep link or restored tab from before the salon
      // edited its categories, or a malformed segment (Number(...) -> NaN;
      // the /:establishmentId/menu route matches any trailing path). Without
      // this guard the next line dereferences undefined; the throw happens
      // inside the pathname effect and, with no error boundary in the app,
      // React unmounts the whole tree — dead until a full reload. Mirrors the
      // guard TileStructure already had. Note menuCategoryFilter can NOT
      // trigger this: the lookup above runs over the unfiltered list (see the
      // regression tests).
      if (!menuCategory) {
        history.push(`/${establishmentId}`)
        return undefined
      }

      if (menuCategory.activities) {
        const isPersonSelectable = isPersonSelectableCheck(menuCategory)
        const pathUrl = personSelectPathCheck(
          settings.isPersonPreferenceMandatory,
          isPersonSelectable,
          establishmentId,
          currentCustomerIndex
        )
        dispatch(addMenu(menuCategory.activities, menuCategory.id))
        history.push(pathUrl)
      }

      return menuCategoryFilter(
        menuCategories,
        settings.isCertainServiceBlock,
        isExistingCustomer
      )
    }

    return getCurrentCategories(breadcrumbs.splice(1), menuCategory.categories)
  }

  useEffect(() => {
    if (!settings || !categories) {
      return
    }
    const breadcrumbs: number[] = location.pathname
      .split('/')
      .splice(3)
      .filter(Boolean)
      .map((breadcrumb): number => Number(breadcrumb))
    setCurrentCategories(getCurrentCategories(breadcrumbs, categories))
  }, [categories, location.pathname, settings])

  if (settings && !settings.isMenuVisible) {
    const activityUrl = `/${establishmentId}/activities`
    history.push(activityUrl)
    return <Spinner />
  }

  if (
    currentCategories === null ||
    typeof currentCategories === 'undefined' ||
    typeof lastMinutes === 'undefined'
  ) {
    return <AbsoluteSpinner />
  }

  return (
    <View>
      <ListStructureMap currentCategories={currentCategories} />
    </View>
  )
}
